export enum ChartVariation {
  Basic = "basic",
  Advanced = "advanced",
  Chartist = "chartist",
}

export interface ChartWindow extends Window {
  frames: {
    chartIFrame: {
      dragscroll: {
        reset: () => void;
      };
      stxx: {
        chart?: {
          series?: [];
          dataSet?: [];
          dataSegment?: [];
        };
        layout: {
          headsUp?: string;
        };
        cleanupGaps?: string;
        setGapLines: (params: {
          color?: string;
          width?: number;
          pattern?: number[];
        }) => void;
        bypassRightClick: {
          series: boolean;
          study: boolean;
          drawing: boolean;
        };
      };
    };
  } & Window;
}

export interface DataSegmentItem {
  Open: number;
  High: number;
  Low: number;
  Close: number;
  Volume: number;
  Date: string;
  DT: string;
  ratio: number;
  iqPrevClose: number;
  atr: number;
  trueRange: number;
  "hl/2": number;
  "hlc/3": number;
  "hlcc/4": number;
  "ohlc/4": number;
  cache: {
    Close: number;
  };
  tick: number;
  candleWidth: number | null;
}

export interface InternalBenchmark {
  parameters: {
    color: string;
    display: string;
  };
}
